import { Helmet } from 'react-helmet-async';
import { AEO_SITE_URL } from '../lib/aeo/constants';
import { buildGlobalAeoJsonLd } from '../lib/aeo/jsonLd';

/** Site-wide AEO: JSON-LD + llms.txt discovery link (all routes). */
export default function AeoGlobalHead() {
  const jsonLd = buildGlobalAeoJsonLd();

  return (
    <Helmet>
      <link rel="alternate" type="text/markdown" href="/llms.txt" title="LLM site overview" />
      <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      <meta
        name="description"
        content="SELF Labs — SELF Phone, humanoid robotics (SELF Bot X1, P1), quadrupeds (SELF Dog), Living Websites, Resonatia AI API, BLOOD licensing, and custom AI software."
      />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <meta property="og:site_name" content="SELF Labs" />
      <meta property="og:url" content={AEO_SITE_URL} />
    </Helmet>
  );
}
